import React, { useState, useEffect } from "react";
import Spinner from "../components/common/spinner/Spinner";
import DataTable from "react-data-table-component-with-filter";
import jwtDecode from "../utils/jwtDecode";

import { adminPanel } from "../services/apis";
import { useHistory, Link } from "react-router-dom";
import { usePermissionsContext } from "../context/contextPermissions";


import "./Search.css";

function Admin() {
  const history = useHistory();

  var adminColumns = [
    {
      name: "Client",
      selector: (adminData) => adminData.client,
    },
    {
      name: "In llh benchmark",
      selector: (adminData) => adminData.in_llh_benchmark.toString(),
    },
    {
      name: "Can upload study",
      selector: (adminData) => adminData.can_upload_study.toString(),
    },
  ];
  const [adminData, setAdminData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const { permissions, setPermissions } = usePermissionsContext();
  const [columns, setColumns] = useState(adminColumns)

  const orderArray = (objArray) => {
    var obj = objArray.sort(function (a, b) {
      var textA = a.toUpperCase();
      var textB = b.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    return obj
  }

  useEffect(() => {
    async function init() {
      try {
        var jwt = localStorage.getItem("jwt", jwt);
        var tableData = await adminPanel(jwt);
        var curData = tableData;
        var columnsMarket = [];

        for (let i = 0; i < curData.length; i++) {
          var curMarkets = curData[i];
          // Change false by no and true by yes

          curMarkets.can_upload_study == false ? curMarkets.can_upload_study = 'NO' : curMarkets.can_upload_study = 'YES'
          curMarkets.in_llh_benchmark == false ? curMarkets.in_llh_benchmark = 'NO' : curMarkets.in_llh_benchmark = 'YES'

          var allStudiesByMarket = curMarkets.studies_by_market;
          if (allStudiesByMarket != null) {
            for (let j = 0; j < allStudiesByMarket.length; j++) {
              var curMarket = allStudiesByMarket[j]
              if (!columnsMarket.includes(curMarket.market)) {
                columnsMarket.push(curMarket.market);
              }
              curMarkets[curMarket.market] = curMarket.count.toString()
            }
          }
        }
        var allColumns = columns;
        var columnsMarketOrder = orderArray(columnsMarket);
        for (let k = 0; k < columnsMarketOrder.length; k++) {
          var curCountry = columnsMarketOrder[k];

          allColumns.push(
            {
              name: curCountry,
              selector: (adminData) => adminData[columnsMarketOrder[k]],
            }
          )
        }

        setColumns(allColumns)
        setAdminData(curData);
        setIsLoading(false);
      } catch (ex) {
        // console.log("ex", ex);
        if (ex.response && ex.response.status === 401) {
        }
      }
    }
    init();
  }, []);

  return (
    <div className="search-page">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {permissions.studies_details ? (
            <DataTable
              columns={columns}
              data={adminData}
              pagination
            />
          ) : (
            <DataTable
              columns={columns}
              data={adminData}
              pagination
            />
          )}
        </>
      )}
    </div>
  );
}

export default Admin;
